export const data = {
  experience: [
    {
      title: 'Coed Softball',
      subTitle: 'Aspen, Colorado',
      description: 'Team Captain'
    },
    
  ],
  education: [
    {
      title: "Denver University",
      subTitle: "Trinity Coding Bootcamp",
      description: "Full Stack Web Development"
    },
    
  ]
}